export type OrdersBasketWorkspaceMetaActions = OrdersBasketTabContentAllFetched;

export function ordersBasketTabContentAllFetched() {
  return { type: 'ORDERS_BASKET_TAB_CONTENT_ALL_FETCHED' as const };
}
export type OrdersBasketTabContentAllFetched = ReturnType<typeof ordersBasketTabContentAllFetched>;
